// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2kLdC){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3oIFl .dualColumn_3WLC0{display:flex;align-content:space-between}.nsAddressForm_3oIFl .dualColumn_3WLC0 .firstCol_131ht{margin-right:20px}.optional_t8Owk{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2kLdC",
	"nsAddressForm": "nsAddressForm_3oIFl",
	"dualColumn": "dualColumn_3WLC0",
	"firstCol": "firstCol_131ht",
	"optional": "optional_t8Owk"
};
module.exports = exports;
